import { render, staticRenderFns } from "./AlertAccountdelete.vue?vue&type=template&id=dfa5bc70&scoped=true"
import script from "./AlertAccountdelete.vue?vue&type=script&lang=js"
export * from "./AlertAccountdelete.vue?vue&type=script&lang=js"
import style0 from "./AlertAccountdelete.vue?vue&type=style&index=0&id=dfa5bc70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa5bc70",
  null
  
)

export default component.exports